import axiosInstance from "../../../../setup/axios/SetupAxios";
const API_URL = process.env.REACT_APP_BASE_URL;

export const SOCIAL_APPS_URL = `${API_URL}/api/v1/parent/social-apps`;

export function getSocialApps(payload) {
  return axiosInstance({
    url: SOCIAL_APPS_URL,
    method: "GET",
    params: payload
  });
}
